
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 64 64"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M26.722 42l3.89 3.889L44.5 32 30.611 18.111 26.722 22l7.222 7.222H7v5.556h26.944L26.722 42zM51.444 7H12.556C9.5 7 7 9.5 7 12.556v11.11h5.556v-11.11h38.888v38.888H12.556v-11.11H7v11.11C7 54.5 9.5 57 12.556 57h38.888C54.5 57 57 54.5 57 51.444V12.556C57 9.5 54.5 7 51.444 7z","fill":"#FF8200"}})])
          )
        }
      }
    